/* eslint-disable no-console */
import wrapper from 'wrapper';
import Chart from './components/chart/chart';

const root = wrapper.select('#newsspec-27716');
root.classList.remove('no-js');
if (!!window.MSInputMethodContext && !!document.documentMode) {
    root.classList.add('ie');
}

function checkTwoCol() {
    if (wrapper.select('.container').offsetWidth < 650) {
        wrapper.select('.container').classList.add('two-column');
    }
    else if (wrapper.select('.two-column')) {
        wrapper.select('.two-column').remove();
    }
}

const { language, locale } = wrapper.getConfig();
const { polls } = wrapper.getConfig().app.data;

const options = {
    language,
    locale,
    scope: wrapper.scope,
};

new Chart(polls, options);

window.addEventListener('resize', checkTwoCol());

wrapper.select('.skip-link')
    .addEventListener('click', (ev) => {
        ev.preventDefault();
        const destinationElt = wrapper.select(ev.target.getAttribute('href'));
        const scrollToPosition = destinationElt.getBoundingClientRect().top;
        // Not sure why we need scrollTo() but it seems we do
        wrapper.scrollTo({ position: scrollToPosition, duration: 1 });
        destinationElt.focus({ preventScroll: false });
    });

wrapper.select('.toggle')
    .addEventListener('change', () => wrapper.trackClick('individual polls toggled'));

wrapper.markPageAsLoaded();
